export default __webpack_public_path__ + "social-development_sm.b7f1240f.png";